<div class="card mb-0" *ngIf="loadingCounselling || loadingPatientInfo">
    <div class="card-body p-2">
        <div class="d-flex align-items-center">
            <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
            <span class="ml-2">Please wait while loading {{loadingCounselling ? 'Counselling' : 'Patient'}} Details ...</span>
        </div>
    </div>
</div>
<div class="card mb-0" *ngIf="!loadingCounselling && !counselling && counsellingId">
    <div class="card-body p-2">
        <div class="mh-400 position-relative">
            <no-data [title]="'Counselling Details'"></no-data>
        </div>
    </div>
</div>
<div class="card mb-0" *ngIf="!loadingPatientInfo && !patientInfo && !counsellingId">
    <div class="card-body p-2">
        <div class="mh-400 position-relative">
            <no-data [title]="'Patient Details'"></no-data>
        </div>
    </div>
</div>
<form [formGroup]="counsellingForm" *ngIf="!loadingCounselling && !loadingPatientInfo && (counselling || patientInfo)">
    <div class="card mb-0">
        <div class="card-body p-2">
            <fieldset class="form-fieldset">
                <legend class="text-primary">Counselling Details</legend>
                <div class="row row-sm">
                    <div class="col-6 col">
                        <div class="form-group">
                            <label class="font-13 font-weight-bold mb-0">Location</label>
                            <ng-select [items]="locations" [ngClass]="{ 'is-invalid': isSubmitted && form.locationId?.errors }" [loading]="loadingLocations" [clearable]="true" bindLabel="name" bindValue="id" [notFoundText]="'No Locations found'" placeholder="Select location" formControlName="locationId">
                                <ng-template ng-option-tmp let-item="item">
                                    <span class="font-weight-normal font-12" [textContent]="item.name"></span>
                                </ng-template>
                                <ng-template ng-label-tmp let-item="item">
                                    <span class="font-weight-normal font-12" [textContent]="item.name"></span>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-6 col">
                        <div class="form-group">
                            <label class="font-13 font-weight-bold mb-0">Package</label>
                            <ng-select  [items]="packageModules" [ngClass]="{ 'is-invalid': isSubmitted && form.packageModule?.errors }" [loading]="loadingPackageModules" [clearable]="true" bindLabel="packageName" placeholder="Select package" formControlName="packageModule">
                            <ng-template ng-option-tmp let-item="item">
                                <div class="d-flex font-weight-normal align-items-center justify-content-between">
                                    <span [textContent]="item.packageName"></span>
                                    <small class="text-mute" [textContent]="item.moduleTypeName + ' / ' + item.packageTypeName"></small>
                                </div>
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                                <span class="font-weight-normal font-13" [textContent]="item.packageName"></span>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                <div class="ng-option disabled">
                                    No Packages found found for '{{searchTerm}}'
                                </div>
                            </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-6 col">
                        <div class="form-group mb-0">
                            <label class="font-13 font-weight-bold mb-0">Charge Category</label>
                            <ng-select [items]="chargeCategories" [ngClass]="{ 'is-invalid': isSubmitted && form.chargeCategory?.errors }" [loading]="loadingChargeCategories" [clearable]="true"  placeholder="Select charge category" bindLabel="name" formControlName="chargeCategory">
                                <ng-template ng-option-tmp let-item="item">
                                    <span class="font-weight-normal font-12" [textContent]="item.name"></span>
                                </ng-template>
                                <ng-template ng-label-tmp let-item="item">
                                    <span class="font-weight-normal font-12" [textContent]="item.name"></span>
                                </ng-template>
                                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                    <div class="ng-option disabled">
                                        No Charge Category found found for '{{searchTerm}}'
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-6 col">
                        <div class="form-group mb-0">
                            <label class="font-13 font-weight-bold mb-0">Counselling Type</label>
                            <ng-select [items]="counsellingTypes" [ngClass]="{ 'is-invalid': isSubmitted && form.counsellingTypeId?.errors }" [loading]="loadingCounsellingTypes" [clearable]="true" bindLabel="name" bindValue="id" placeholder="Select Counselling Type" formControlName="counsellingTypeId">
                                <ng-template ng-option-tmp let-item="item">
                                    <span class="font-weight-normal font-13" [textContent]="item.name"></span>
                                </ng-template>
                                <ng-template ng-label-tmp let-item="item">
                                    <span class="font-weight-normal font-13" [textContent]="item.name"></span>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                </div>
            </fieldset>
            <div class="no-package-container" *ngIf="!showPackageInfo">
                <img src="/assets/images/package-preview.png" alt="Counselling Preview" />
                <p class="mt-2 mb-0 text-mute">To preview the counselling, please select the package and charge category.</p>
            </div>
            <ng-container *ngIf="showPackageInfo">
                <fieldset class="form-fieldset">
                    <legend class="text-primary">Payment Details</legend>
                    <div class="row row-sm">
                        <div class="col-6 col">
                            <div class="form-group">
                                <label class="font-13 font-weight-bold mb-0">Pay Type</label>
                                <ng-select [items]="payTypes" [loading]="loadingPayTypes" [clearable]="true" bindLabel="name" bindValue="id" placeholder="Select Pay Type" formControlName="payTypeId">
                                    <ng-template ng-option-tmp let-item="item">
                                        <span class="font-weight-normal font-13" [textContent]="item.name"></span>
                                    </ng-template>
                                    <ng-template ng-label-tmp let-item="item">
                                        <span class="font-weight-normal font-13" [textContent]="item.name"></span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-6 col">
                            <div class="form-group">
                                <label class="font-13 font-weight-bold mb-0">Insurance Company</label>
                                <ng-select [items]="insuranceCompanies" [loading]="loadingInsuranceCompanies" [clearable]="true" bindLabel="value" bindValue="id" placeholder="Select Insurance Type" formControlName="insuranceCompanyId">
                                    <ng-template ng-option-tmp let-item="item">
                                        <span class="font-weight-normal font-13" [textContent]="item.value"></span>
                                    </ng-template>
                                    <ng-template ng-label-tmp let-item="item">
                                        <span class="font-weight-normal font-13" [textContent]="item.value"></span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-6 col">
                            <div class="form-group mb-0">
                                <label class="font-13 font-weight-bold mb-0">TPA Organization</label>
                                <ng-select [items]="tpas" [loading]="loadingTPAs" [clearable]="true" bindLabel="value" bindValue="id" placeholder="Select TPA Organization" formControlName="tpaId">
                                    <ng-template ng-option-tmp let-item="item">
                                        <span class="font-weight-normal font-13" [textContent]="item.value"></span>
                                    </ng-template>
                                    <ng-template ng-label-tmp let-item="item">
                                        <span class="font-weight-normal font-13" [textContent]="item.value"></span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <!--<div class="col-6 col">
                            <div class="form-group mb-0">
                                <label class="font-13 font-weight-bold mb-0">Patient Organization</label>
                                <input type="text" class="form-control font-13" formControlName="patientOrganization" maxlength="50" titleOnly block autocomplete="nope" placeholder="Enter Patient Working Organization" />
                            </div>
                        </div>-->
                    </div>
                </fieldset>
                <fieldset class="form-fieldset">
                    <legend class="text-primary">Package Details</legend>
                    <view-package-module [packageModuleId]="form.packageModule?.value.packageModuleId" [chargeCategory]="form.chargeCategory?.value" [isCounselling]="true" [chargeCategoryId]="form.chargeCategory?.id"></view-package-module>
                    <table class="table table-centered package-amounts mb-0 mt-2">
                        <tbody>
                            <tr>
                                <td class="border-0 pb-0">Total Quantity</td>
                                <td class="border-0 pb-0" [textContent]="form.totalQuantity?.value || 0"></td>
                            </tr>
                            <tr>
                                <td class="pb-0">Sub Total</td>
                                <td class="pb-0" [textContent]="(form.subTotal?.value || 0) | currency :'₹ ':'symbol':'1.2-2'"></td>
                            </tr>
                            <tr>
                                <td class="pb-0">Package Discount</td>
                                <td class="pb-0" [textContent]="(form.packageDiscount?.value || 0) | currency :'₹ ':'symbol':'1.2-2'"></td>
                            </tr>
                            <tr>
                                <td class="pb-0" style="vertical-align: top !important;">Counselling Discount</td>
                                <td class="pb-0">
                                    <div class="form-group mb-1">
                                        <select formControlName="discountType" (change)="onChangeDiscount('discountType')" class="form-control-sm pl-1 form-control font-weight-normal text-left">
                                            <option [value]="'A'">Amount</option>
                                            <option [value]="'P'">Percentage</option>
                                        </select>
                                    </div>
                                    <div class="form-group mb-0" *ngIf="form.discountType?.value === 'P'">
                                        <div class="input-group input-group-sm mb-0">
                                            <input class="form-control-sm form-control" type="number" (input)="onChangeDiscount('discountPercentage', $event.target.value)" #discountPercentage min="1" max="100" step="1" block [value]="form.discountPercentage?.value" placeholder="###.##">
                                            <div class="input-group-text input-group-append">%</div>
                                        </div>
                                    </div>
                                    <div class="form-group mb-0" *ngIf="form.discountType?.value === 'A'">
                                        <div class="input-group input-group-sm mb-0">
                                            <div class="input-group-text input-group-prepend">₹</div>
                                            <input class="form-control-sm form-control" type="number" (input)="onChangeDiscount('discountAmount', $event.target.value)" #discountAmount min="1" max="1000" step="1" block [value]="form.discountAmount?.value" placeholder="###.##">
                                        </div>
                                    </div>
                                    <small class="text-mute" *ngIf="form.discountType?.value === 'P'" [textContent]="(form.discount?.value || 0) | currency :'₹ ':'symbol':'1.2-2'"></small>
                                </td>
                            </tr>
                            <tr class="font-15 font-weight-bold">
                                <td class="pb-0">Counselling Total</td>
                                <td class="pb-0" [textContent]="(form.total?.value || 0) | currency :'₹ ':'symbol':'1.2-2'"></td>
                            </tr>
                        </tbody>
                    </table>
                </fieldset>
                <div class="col-12 col">
                    <div class="form-group">
                        <label class="mb-0 font-weight-bold font-13">Comments</label>
                        <textarea type="text" class="form-control font-13" style="height: 60px" rows="3" cols="25" block formControlName="comments" placeholder="Enter comments" autocomplete="nope"></textarea>
                    </div>
                </div>
                <div class="row row-sm mt-3">
                    <div class="col-6 col">
                        <div class="form-group mb-0 d-flex flex-column">
                            <label class="font-13 font-weight-bold mb-0 text-primary">Counselling Given To</label>
                            <div class="d-flex font-13 align-items-center mb-1" *ngIf="patientInfo">
                                <p class="mb-0 font-weight-semibold text-capitalize">
                                    <span [textContent]="patientInfo.patientName"></span>
                                    <small *ngIf="patientInfo.patientGender" [textContent]="' (' + patientInfo.patientGender + ')'"></small>
                                </p>
                                <small class="text-mute ml-1" [textContent]="'/ ' + patientInfo.umrNo"></small>
                            </div>
                            <div class="d-flex font-13 align-items-center mb-1" *ngIf="counselling">
                                <p class="mb-0 font-weight-semibold text-capitalize">
                                    <span [textContent]="counselling.patientName"></span>
                                    <small *ngIf="counselling.patientGender" [textContent]="' (' + counselling.patientGender + ')'"></small>
                                </p>
                                <small class="text-mute ml-1" [textContent]="'/ ' + counselling.umrNo"></small>
                            </div>
                            <div class="signature-container" [class.has-image]="form.patientBase64Signature?.value || form.patientSignature?.value" (click)="onOpenModel(templateSignature, 'Counselling Given To')">
                                <img class="img-fluid" alt="Patient Signature" *ngIf="form.patientBase64Signature?.value" [src]="form.patientBase64Signature?.value" />
                                <img class="img-fluid" alt="Patient Signature" *ngIf="!form.patientBase64Signature?.value && counselling?.patientSignatureRootPath && form.patientSignature?.value" [src]="page.getImage(counselling.patientSignatureRootPath + form.patientSignature?.value)" />
                                <p><span class="mdi mdi-pencil-outline mr-1"></span> Signature</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 col">
                        <div class="form-group mb-0 d-flex flex-column align-items-end">
                            <label class="font-13 font-weight-bold mb-0 text-primary">Counsellor<small class="ml-1">(Counselling Given By)</small></label>
                            <div class="d-flex font-13 align-items-center mb-1" *ngIf="patientInfo">
                                <p class="mb-0 font-weight-semibold text-capitalize" [textContent]="page.userAccount.fullName"></p>
                                <small class="text-mute ml-1" [textContent]="' / ' + page.userAccount.roleName"></small>
                            </div>
                            <div class="d-flex font-13 align-items-center mb-1" *ngIf="counselling">
                                <p class="mb-0 font-weight-semibold text-capitalize" [textContent]="counselling.createdByName"></p>
                                <small class="text-mute ml-1" [textContent]="' / ' + (counselling.createdDate | amDateFormat : 'DD-MM-YYYY hh:mm a')"></small>
                            </div>
                            <div class="signature-container" [class.has-image]="form.counsellorBase64Signature?.value || form.counsellorSignature?.value" (click)="onOpenModel(templateSignature, 'Counsellor')">
                                <img class="img-fluid" alt="Counsellor Signature" *ngIf="form.counsellorBase64Signature?.value" [src]="form.counsellorBase64Signature?.value" />
                                <img class="img-fluid" alt="Counsellor Signature" *ngIf="!form.counsellorBase64Signature?.value && counselling?.counsellorSignatureRootPath && form.counsellorSignature?.value" [src]="page.getImage(counselling.counsellorSignatureRootPath + form.counsellorSignature?.value)" />
                                <p><span class="mdi mdi-pencil-outline mr-1"></span> Signature</p>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <ng-container *ngIf="showPackageInfo">
            <hr class="my-2" />
            <div class="d-flex mb-2 mr-2 align-items-center justify-content-end">
                <button type="button" (click)="onSaveAsDraft()" [disabled]="isSubmitting || isSavingDraft" class="btn btn-sm mb-0 ml-0 btn-warning">
                    <span *ngIf="isSavingDraft">
                        <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        Please wait..
                    </span>
                    <span *ngIf="!isSavingDraft">Save Draft</span>
                </button>
                <button type="button" (click)="onSubmit()" [disabled]="isSubmitting || isSavingDraft" class="btn btn-sm mb-0 ml-1 btn-primary">
                    <span *ngIf="isSubmitting">
                        <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        Please wait..
                    </span>
                    <span *ngIf="!isSubmitting">Publish</span>
                </button>
                <button type="button" (click)="onCancel()" [disabled]="isSubmitting || isSavingDraft" class="btn btn-sm mb-0 ml-1 btn-secondary">Cancel</button>
            </div>
        </ng-container>
    </div>
</form>
<ng-template #templateSignature>
    <div class="modal-header">
        <h4 class="modal-title">
            <span class="btn-group">
                <button type="button" class="btn btn-xs" [class.btn-warning]="signatureType === 'signature'" title="Signature" [class.btn-outline-light]="signatureType === 'digital'" (click)="signatureType = 'signature'">Draw</button>
                <button type="button" class="btn btn-xs" [class.btn-warning]="signatureType === 'digital'" title="Digital" [class.btn-outline-light]="signatureType === 'signature'" (click)="signatureType = 'digital'">Upload</button>
            </span>
            <span style="position: relative; top: 1px; left: 10px;">{{signatureFor}} Signature</span>
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal();">×</button>
    </div>
    <div class="modal-body">
        <div class="d-flex align-items-center" *ngIf="isSaveSignature">
            <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
            <span class="ml-2">Please wait while saving uploaded signature...</span>
        </div>
        <img-crop *ngIf="signatureType === 'digital'" [image]="null" [aspectRatio]="4/4" [resizeToWidth]="250" (croppedImageEmitter)="onReceiveDrewSignature($event)"></img-crop>
        <!--<image-drawing #imageId *ngIf="signatureType === 'signature'" src="assets/images/whiteBackground.png" outputQuality="0.5" borderCss="1px solid black" [showCancelButton]="false" [drawingSizes]="{ small: 3, medium: 5 }" width="400" height="250" (save)="onSaveUploadedSignature($event)">
        </image-drawing>-->
        <signature-widget *ngIf="signatureType === 'signature'" width="500"
                          height="200"
                          (done)="onSignatureDone($event)"></signature-widget>
    </div>
    <div class="modal-footer" *ngIf="signatureType === 'digital'">
        <button type="button" class="btn btn-sm btn-secondary mr-1" (click)="onCloseModal();">Close</button>
        <button type="button" (click)="onCloseModal()" class="btn btn-sm btn-primary">Submit</button>
    </div>
</ng-template>